<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="logo-container">
    <img class="logo" src="assets/microsoft-entra-ID-color-icon.svg" alt="Entra ID Logo">
    <span class="logo-text">Microsoft Entra ID</span>
</div>

<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <ng-container *ngIf="!(loading$ | async); else loadingSkeleton">
            <div>
                <mat-form-field class="field-input" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'AD_TENANT_ID' | translate}}</mat-label>
                    <input matInput type=text id="tenant_id" formControlName="tenant_id" [attr.disabled]="disableTenantId">
                    <mat-error *ngIf="this.formGroup.controls['tenant_id'].errors && this.formGroup.controls['tenant_id'].errors['duplicate']">{{'AD_DUPLICATE_TENANT_ERROR' | translate}}</mat-error>
                    <mat-error *ngIf="this.formGroup.controls['tenant_id'].errors && this.formGroup.controls['tenant_id'].errors['invalidUuid']">{{'INVALID_UUID' | translate}}</mat-error>
                </mat-form-field>
            </div>

            @if (integration?.config?.enable_all === true || controls.length == 0) {
                <div class="toggle-field">
                    <label class="toggle-label">
                        {{ 'AD_ENABLE_ALL' | translate }}
                    </label>

                    <mat-slide-toggle
                        aria-labelledby="enable-all-key"
                        aria-label="Enable all active directory users"
                        color="primary"
                        [disableRipple]="true"
                        id="enable_all"
                        formControlName="enable_all">
                    </mat-slide-toggle>
                </div>
            }

            <div>
                <span
                    *ngIf="formGroup.controls['enable_all'].errors?.roleError"
                    class="toggle-label role-error">
                    {{ 'AD_ERROR_ROLE' | translate }}
                </span>
            </div>

            <div class="group-wrapper">
                <div class="add-group-btn">
                    <button id="add-group-button" mat-button (click)="onAddGroupClick()" aria-label="Add Group and Role.">
                      <div class="icon-button-text-wrapper">
                          <i class="mdi mdi-plus-box-outline"></i>
                          <span class="add-button-label">{{ 'AD_GROUP_AND_ROLE' | translate }}</span>
                      </div>
                    </button>
                </div>

                <form [formGroup]="formGroup">
                    <div formArrayName="groups" *ngFor="let control of controls; let i = index;" class="group-row-wrapper">
                        <div class="group-row" [formGroupName]="i">
                            <mat-form-field floatLabel="never" class="group-form-field" appearance="outline">
                                <input matInput id="group_id" formControlName="group_id" placeholder="{{'AD_GROUP_ID' | translate}}"/>
                                <mat-error *ngIf="hasUuidError(i)">{{'INVALID_UUID' | translate}}</mat-error>
                            </mat-form-field>
                            <span>
                                <mat-button-toggle-group value="{{control.value.role}}" formControlName="role"
                                                         [appearance]="toggleGroupAppearance"
                                                         [hideSingleSelectionIndicator]="true"
                                                         name="role-toggle-button-group">
                                    <mat-button-toggle id="role-user-{{i}}" value="user" [disabled]="control.value.role === ''" disableRipple="true">{{'AD_USER_ROLE' | translate}}</mat-button-toggle>
                                    <mat-button-toggle id="role-help-{{i}}" value="help-desk" [disabled]="control.value.role === ''" disableRipple="true">{{'AD_HELP_DESK_ROLE' | translate}}</mat-button-toggle>
                                    <mat-button-toggle id="role-admin-{{i}}" value="admin" [disabled]="control.value.role === ''" disableRipple="true">{{'AD_ADMIN_ROLE' | translate}}</mat-button-toggle>
                                </mat-button-toggle-group>
                            </span>
                            <span class="remove-row-icon delete-icon">
                                <button mat-icon-button (click)="deleteGroup(i, $event)" matTooltip="{{'AD_DELETE_GROUP_TOOLTIP' | translate}}" aria-label="Delete group"
                                        matTooltipShowDelay="350" matTooltipPosition="right">
                                    <span class="mdi mdi-close-circle-outline"></span>
                                </button>
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </ng-container>
        <ng-template #loadingSkeleton>
            <ngx-skeleton-loader appearance="line" [theme]="{ height: '56px', width: '600px', display: 'flex', margin: '0 0 25px 20px' }" count="3"></ngx-skeleton-loader>
        </ng-template>
        <div class="action-button-wrapper">
            <button type="button" (click)="cancel()" mat-raised-button>{{'CANCEL_CAP' | translate}}</button>
            <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{'SAVE_CAP' | translate}}</button>
        </div>
    </form>
</div>
